module.exports = __webpack_public_path__ + "static/media/Middle.6e39ad7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/TalkLandingPage/Middle.png
// module id = 1224
// module chunks = 2